import wechat from '@/api/wechat';

import { WECHAT_GRANT, WECHAT_JSSDK } from './types';

export default {
    [WECHAT_GRANT]({ commit }, payload) {
        return wechat.grant(payload.code)
            .then((resp) => {
                commit(WECHAT_GRANT, resp);
            });
    },
    [WECHAT_JSSDK]({ commit }, payload) {
        return wechat
            .jssdk(payload.url)
            .then((resp) => {
                commit(WECHAT_JSSDK, resp);
            });
    },
};



// WEBPACK FOOTER //
// ./src/store/wechat/actions.js